document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-v3-image]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var main=document.getElementById('V3MainProductImage');
      if(main) main.src=btn.getAttribute('data-v3-image');
      document.querySelectorAll('.v3-product__thumb').forEach(function(x){x.classList.remove('is-active')});
      btn.classList.add('is-active');
    });
  });

  var qty=document.getElementById('V3Qty');
  document.querySelectorAll('[data-v3-qty]').forEach(function(btn){
    btn.addEventListener('click',function(){
      if(!qty) return;
      var v=Math.max(1,parseInt(qty.value||'1',10)+(btn.getAttribute('data-v3-qty')==='plus'?1:-1));
      qty.value=v;
    });
  });

  var form=document.getElementById('V3ProductForm');
  var sticky=document.getElementById('V3StickyCart');
  if(form && sticky){
    var obs=new IntersectionObserver(function(entries){
      entries.forEach(function(e){sticky.classList.toggle('is-visible',!e.isIntersecting)});
    },{threshold:.1});
    obs.observe(form);
    var stickyBtn=sticky.querySelector('[data-v3-sticky-add]');
    if(stickyBtn) stickyBtn.addEventListener('click',function(){var submit=form.querySelector('[type="submit"]'); if(submit) submit.click();});
  }
});
